import { useEffect, useState } from 'react';
import * as React from 'react';
import { pcontract } from '@/proto/proto';
import api from '@/api';
import { useParams } from 'react-router';
import { API_COMPANY_CAR_INFO } from '@/constants/constant';

const CompanyCarPage: React.FC = () => {
  const { companyCarId } = useParams<any>();
  const [contracts, setContracts] = useState<pcontract.PbContract[]>();

  useEffect(() => {
    api
      .get(API_COMPANY_CAR_INFO(companyCarId), {
        params: {
          companyId: 1,
        },
      })
      .then(({ data }) => setContracts(data.contract));
  }, [companyCarId]);

  return (
    <>
      <h1>Company Car Page</h1>
    </>
  );
};

export default CompanyCarPage;
